import { put, call, takeEvery, all } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api from '../../../../../../helpers/api';

const calendarApi = new Api('orientations/:id/sessions/list');

function* loadCalendarData({ payload }) {
  try {
    const result = yield call(sendRequest, calendarApi.load, { id: payload }, notifications.REQUEST_ERROR);

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadDataSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadCalendarData)]);
}
